import React from 'react'
import styles from './SearchBar.scss'
import _ from 'lodash'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import {FiltersPopover} from 'features/search/FiltersPopover'

export class SearchBar extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      keywords: props.query.get('keywords', ''),
      filtersExpanded: false
    }
    this.debouncedKeywordUpdate = _.debounce(this.doSearch, 350)
  }

  componentDidMount = () => {
    this.keywordInput.focus()
  }

  doSearch = (params) => {
    const {doSearch, query} = this.props
    const {keywords} = this.state
    const queryWithUpdates = query.merge(Object.assign({keywords: keywords, sort_by: ''}, params)) // Keyword search results are always better sorted by relevance
    doSearch(queryWithUpdates)
  }

  onKeywordChange = (e) => {
    this.setState({keywords: e.target.value}, this.debouncedKeywordUpdate)
  }

  toggleFiltersPopover = () => {
    const {filtersExpanded} = this.state
    this.setState({filtersExpanded: !filtersExpanded})
  }

  render () {
    const {query, doSearch, metricUnits, currentUser} = this.props
    const {keywords, filtersExpanded} = this.state

    return (
      <div className={styles.SearchBar}>
        <div className={styles.searchBox}>
          <input
            className={styles.searchInput}
            type='text'
            placeholder='Search'
            value={keywords}
            ref={(input) => { this.keywordInput = input }}
            onChange={this.onKeywordChange} />
        </div>
        <div className={styles.filter}>
          <CTA
            inline
            secondary
            margins={false}
            className={styles.filterButton}
            ref={r => { this._filtersButton = r }}
            onClick={() => this.toggleFiltersPopover()}>
            <Icon i={'filter'} size={13} />&nbsp;Filter
          </CTA>
        </div>
        {filtersExpanded && <FiltersPopover
          target={this._filtersButton}
          doSearch={doSearch}
          onRequestClose={this.toggleFiltersPopover}
          metricUnits={metricUnits}
          currentUser={currentUser}
          query={query} />}
      </div>
    )
  }
}
